module.exports = __webpack_public_path__ + "img/logo@2x.04bde1e2.png";